import { useEffect, useState } from "react";
import { InviteModal, InviteModalProps } from "./InviteModal";
import { ButtonAnalyticsProvider, useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

interface InviteKmeItemProps extends InviteModalProps {
    // props injected by the MeetingRoom Component
    onClose: () => void;
}

/**
 * Invite external user closeable modal for KME custom menu item
 */
export const InviteKmeItem = (props: InviteKmeItemProps) => {
    const { autoFocus, onCloseMenu, onClose, ...modalProps } = props;

    const [isOpen, setIsOpen] = useState(true);
    const sendButtonAnalytics = useButtonAnalytics();

    useEffect(() => {
        sendButtonAnalytics(
            "Invite user - open modal",
            ButtonClickAnalyticsType.OPEN,
            props.entryId,
            "invitetomedia",
            "Media kme"
        );
    }, []);

    const closeModal = () => {
        setIsOpen(false);
        onClose?.();
    };

    if (isOpen) {
        return (
            <ButtonAnalyticsProvider applicationFeature={"invitetomedia"} location={"Invitation modal"}>
                <InviteModal {...modalProps} onClose={closeModal} />
            </ButtonAnalyticsProvider>
        );
    }
    else {
        return null;
    }
};
